import styled from "styled-components";

export const Page = styled.main`
  gap: 1rem;
  display: flex;
  margin: 0 auto;
  max-width: 950px;
  flex-direction: column;
`;
